export default "__VITE_ASSET__C51UHxU8__"